import React, { useState } from 'react';
import './Price.css';

const Price = () => {
  const [formOption, setFormOption] = useState(1);
  const [roomCount, setRoomCount] = useState(null);
  const [sizes, setSizes] = useState([]);
  const [shopSizes, setShopSizes] = useState([]);

  const [unit, setUnit] = useState('feet');
  const [unitShop, setUnitShop] = useState('feet');
  const [floorCount, setFloorCount] = useState(null);
  const [shopFloorCount, setShopFloorCount] = useState(null);
  const [shopCount, setShopCount] = useState();
  const [tvLobbyOption, settvLobbyOption] = useState(null);
  const [tvLobbySize, setTvLobbySize] = useState({ width: '', height: '' });
  const [kitchenSize, setKitchenSize] = useState({ width: '', height: '' });
  const [bathroomSize, setBathroomSize] = useState({ width: '', height: '' });
  const [diningAreaSize, setDiningAreaSize] = useState({ width: '', height: '' });
  const [livingAreaSize, setLivingAreaSize] = useState({ width: '', height: '' });
  const [carPorchSize, setCarPorchSize] = useState({ width: '', height: '' });
  const [result, setResult] = useState(null);
  const [price, setPrice] = useState(null);
  const [shopResult, setShopResult] = useState(null);
  const [shopPrice, setShopPrice] = useState(null);
  const [carPorchOption, setcarPorchOption] = useState(null);


  const handleRoomCountChange = (e) => {
    const count = e.target.value === "" ? 0 : parseInt(e.target.value);
    if (count <= 15) {
      setRoomCount(count);
      setSizes(Array(count).fill({ width: '', height: '' }));
    }
  };
  const handleShopCountChange = (e) => {
    const count = e.target.value === "" ? 0 : parseInt(e.target.value);
    if (count <= 5) {
      setShopCount(count);
      setShopSizes(Array(count).fill({ width: '', height: '' }));
    }
  };

  
  const handleSizeChange = (index, field, value) => {
    const newSizes = [...sizes];
    newSizes[index] = {
      ...newSizes[index],
      [field]: value,
    };
    setSizes(newSizes);
  };
  
  const handleSizeShopChange = (index, field, value) => {
    const newShopSizes = [...shopSizes];
    newShopSizes[index] = {
      ...newShopSizes[index],
      [field]: value,
    };
    setShopSizes(newShopSizes);
  };
 
  const handleFloorCountChange = (e) => {
    const value = e.target.value === "" ? 0 : parseInt(e.target.value);
    if (value <= 15) {
      setFloorCount(value);
    }
  };
  const handleShopFloorCountChange = (e) => {
    const value = e.target.value === "" ? 0 : parseInt(e.target.value);
    if (value <= 15) {
      setShopFloorCount(value);
    }
  };


  const handleTvLobbySizeChange = (dimension, value) => {
    setTvLobbySize((prevSize) => ({
      ...prevSize,
      [dimension]: value
    }));
  };
  const handleCarPorchSizeChange = (dimension, value) => {
    setCarPorchSize((prevSize) => ({
      ...prevSize,
      [dimension]: value
    }));
  };
  const resetShopForm = () => {
    setShopCount(0);
    setShopSizes([]);
    setUnitShop("feet");
    setShopFloorCount(0);
    setShopResult(null);
    setShopPrice(null);
  
  };
  const resetForm = () => {
    setRoomCount(null);
    setSizes([]);
    setUnit("feet");
    setFloorCount(null);
    settvLobbyOption(null);
    setcarPorchOption(null);
    setResult(null);
    setPrice(null);
    setBathroomSize({ width: '', height: '' });
    setDiningAreaSize({ width: '', height: '' });
    setLivingAreaSize({ width: '', height: '' });
    setKitchenSize({ width: '', height: '' });
  };
  

  const calculateResult = () => {
    let totalArea = 0;
    let totalPrice=0;
  
    const convertToFeet = (value, unit) => {
      if (unit === 'cm') return value * 0.0328084;
      if (unit === 'meters') return value * 3.28084;
      if (unit === 'inches') return value / 12;
      return value; 
    };
  
   
    sizes.forEach((size) => {
      const widthInFeet = convertToFeet(parseFloat(size.width || 0), unit);
      const heightInFeet = convertToFeet(parseFloat(size.height || 0), unit);
      totalArea += widthInFeet * heightInFeet;
    });
  
    const kitchenWidthFeet = convertToFeet(parseFloat(kitchenSize.width), unit);
    const kitchenHeightFeet = convertToFeet(parseFloat(kitchenSize.height || 0), unit);
    totalArea += kitchenWidthFeet * kitchenHeightFeet;

    const bathroomWidthFeet = convertToFeet(parseFloat(kitchenSize.width), unit);
    const bathroomHeightFeet = convertToFeet(parseFloat(kitchenSize.height || 0), unit);
    totalArea += bathroomWidthFeet * bathroomHeightFeet;
  
    const livingWidthFeet = convertToFeet(parseFloat(livingAreaSize.width || 0), unit);
    const livingHeightFeet = convertToFeet(parseFloat(livingAreaSize.height || 0), unit);
    totalArea += livingWidthFeet * livingHeightFeet;

    if(carPorchOption===1){
    const carPorchWidthFeet = convertToFeet(parseFloat(carPorchSize.width || 0), unit);
    const carPorchHeightFeet = convertToFeet(parseFloat(carPorchSize.height || 0), unit);
    totalArea += carPorchWidthFeet * carPorchHeightFeet;
    }

    if (tvLobbyOption === 1) {
      const tvLobbyWidthFeet = convertToFeet(parseFloat(tvLobbySize.width || 0), unit);
      const tvLobbyHeightFeet = convertToFeet(parseFloat(tvLobbySize.height || 0), unit);
      totalArea += tvLobbyWidthFeet * tvLobbyHeightFeet;
    }
    const diningWidthFeet = convertToFeet(parseFloat(diningAreaSize.width || 0), unit);
    const diningHeightFeet = convertToFeet(parseFloat(diningAreaSize.height || 0), unit);
    totalArea += diningWidthFeet * diningHeightFeet;

    totalArea+=totalArea*0.15;
  
    if(floorCount===1 || floorCount===0)
      {
      setResult(`Total Area: ${totalArea.toFixed(2)} Square Feet`);
      totalPrice=totalArea*7500;
      setPrice(`Total Amount(Approximate) : LKR ${totalPrice.toLocaleString()}`);
      }
    else
      {
      setResult(`Total Area: ${totalArea.toFixed(2)} Square Feet`);
      totalPrice=totalArea*7000;
      setPrice(`Total Amount(Approximate) : LKR ${totalPrice.toLocaleString()}`);
      } 
  };

  const calculateShopResult = () => {
    let totalShopArea = 0;
    let totalShopPrice=0;

    const convertToFeet = (value, unit) => {
      if (unitShop === 'cm') return value * 0.0328084;
      if (unitShop === 'meters') return value * 3.28084;
      if (unitShop === 'inches') return value / 12;
      return value;
    };

    shopSizes.forEach((size) => {
      const shopWidthInFeet = convertToFeet(parseFloat(size.width || 0), unitShop);
      const shopHeightInFeet = convertToFeet(parseFloat(size.height || 0), unitShop);
      totalShopArea += shopWidthInFeet * shopHeightInFeet;
    });
    totalShopArea+=totalShopArea*0.15;
    if(shopFloorCount===1 || shopFloorCount===1)
      {
      setShopResult(`Total Area: ${totalShopArea.toFixed(2)} Square Feet`);
      totalShopPrice=totalShopArea*4500;
      setShopPrice(`Total Amount(Approximate) : LKR ${totalShopPrice.toLocaleString()}`);
      }
    else
      {
      setShopResult(`Total Area: ${totalShopArea.toFixed(2)} Square Feet`);
      totalShopPrice=totalShopArea*4000;
      setShopPrice(`Total Amount(Approximate) : LKR ${totalShopPrice.toLocaleString()}`);
      }
  }
  

  return (
    <div className="container1">
      <h1>Get Your Price</h1>
      <div className="form-section">
        <label>
          <input
            type="radio"
            name="formOption"
            value="1"
            onChange={() => setFormOption(1)}
          />{' '}
          House
        </label>
        <label>
          <input
            type="radio"
            name="formOption"
            value="2"
            onChange={() => setFormOption(2)}
          />{' '}
          Commercial Site
        </label>
      </div>

      {formOption === 1 && (
        <div className="glass-form">
          <h2>House</h2>

          <label>
            How many rooms do you need?
            <br />
            <input
              type="number"
              value={roomCount}
              onChange={handleRoomCountChange}
              min="0"
            />
          </label>

          {sizes.map((_, index) => (
            <div key={index} className="size-input">
              <label>
                Room {index + 1} Size:
                <br />
                <input
                  type="number"
                  placeholder="Width"
                  value={sizes[index].width}
                  onChange={(e) => handleSizeChange(index, 'width', e.target.value)}
                />
  
                <input
                  type="number"
                  placeholder="Height"
                  value={sizes[index].height}
                  onChange={(e) => handleSizeChange(index, 'height', e.target.value)}
                />
                <select value={sizes[index].unit} onChange={(e) => handleSizeChange(index, 'unit', e.target.value)}>
                  <option value="feet">feet</option>
                  <option value="inches">inches</option>
                  <option value="cm">cm</option>
                  <option value="meters">meters</option>
                </select>
              </label>
            </div>
          ))}
          <br />
          <br />
         
          <label>
            Size of Kitchen:
            <br />
            <input
              type="number"
              placeholder="Width"
              value={kitchenSize.width}
              onChange={(e) => setKitchenSize({ ...kitchenSize, width: e.target.value })}
            />
            <input
              type="number"
              placeholder="Height"
              value={kitchenSize.height}
              onChange={(e) => setKitchenSize({ ...kitchenSize, height: e.target.value })}
            />
            <select value={unit} onChange={(e) => setUnit(e.target.value)} >
              <option value="feet">feet</option>
              <option value="inches">inches</option>
              <option value="cm">cm</option>
              <option value="meters">meters</option>
            </select>
          </label>
          <br />
          <br />
          
          <label>
            Size of Living Area:<br />
            <input
              type="number"
              placeholder="Width"
              value={livingAreaSize.width}
              onChange={(e) => setLivingAreaSize({ ...livingAreaSize, width: e.target.value })}
            />
            <input
              type="number"
              placeholder="Height"
              value={livingAreaSize.height}
              onChange={(e) => setLivingAreaSize({ ...livingAreaSize, height: e.target.value })}
            />
            <select value={unit} onChange={(e) => setUnit(e.target.value)} >
              <option value="feet">feet</option>
              <option value="inches">inches</option>
              <option value="cm">cm</option>
              <option value="meters">meters</option>
            </select>
          </label>
            <br />
            <br />

          <label>
            Size of Bathroom:
            <br />
            <input
              type="number"
              placeholder="Width"
              value={bathroomSize.width}
              onChange={(e) => setBathroomSize({ ...bathroomSize, width: e.target.value })}
            />
            <input
              type="number"
              placeholder="Height"
              value={bathroomSize.height}
              onChange={(e) => setBathroomSize({ ...bathroomSize, height: e.target.value })}
            />
            <select value={unit} onChange={(e) => setUnit(e.target.value)} >
              <option value="feet">feet</option>
              <option value="inches">inches</option>
              <option value="cm">cm</option>
              <option value="meters">meters</option>
            </select>
          </label>
            <br />
            <br />

          <label>
            Size of Dining Area:
            <br />
            <input
              type="number"
              placeholder="Width"
              value={diningAreaSize.width}
              onChange={(e) => setDiningAreaSize({ ...diningAreaSize, width: e.target.value })}
            />
            <input
              type="number"
              placeholder="Height"
              value={diningAreaSize.height}
              onChange={(e) => setDiningAreaSize({ ...diningAreaSize, height: e.target.value })}
            />
            <select value={unit} onChange={(e) => setUnit(e.target.value)} >
              <option value="feet">feet</option>
              <option value="inches">inches</option>
              <option value="cm">cm</option>
              <option value="meters">meters</option>
            </select>
          </label>
          <br />
          <br />
        
          <label>
            Do you want a Car Porch?
            <br />
            <label>
              <input
                type="radio"
                name="carPorchOption"
                value="1"
                onChange={() => setcarPorchOption(1)}
              />{' '}
              Yes
            </label>
            <label>
              <input
                type="radio"
                name="carPorchOption"
                value="2"
                onChange={() => setcarPorchOption(2)}
              />{' '}
              No
            </label>
          </label>

          {carPorchOption === 1 && (
            <div className="size-input">
              <label>
                Car Porch Size:<br />
                <input
                  type="number"
                  placeholder="Width"
                  value={carPorchSize.width}
                  onChange={(e) => handleCarPorchSizeChange('width', e.target.value)}
                />
                <input
                  type="number"
                  placeholder="Height"
                  value={carPorchSize.height}
                  onChange={(e) => handleCarPorchSizeChange('height', e.target.value)}
                />
                <select value={unit} onChange={(e) => setUnit(e.target.value)} >
                  <option value="feet">feet</option>
                  <option value="inches">inches</option>
                  <option value="cm">cm</option>
                  <option value="meters">meters</option>
                </select>
              </label>
            </div>
          )}
          <br />
          <br />
 
          <label>
            Do you want a TV Lobby?
            <br />
            <label>
              <input
                type="radio"
                name="tvLobbyOption"
                value="1"
                onChange={() => settvLobbyOption(1)}
              />{' '}
              Yes
            </label>
            <label>
              <input
                type="radio"
                name="tvLobbyOption"
                value="2"
                onChange={() => settvLobbyOption(2)}
              />{' '}
              No
            </label>
          </label>

          {tvLobbyOption === 1 && (
            <div className="size-input">
              <label>
                TV Lobby Size:<br />
                <input
                  type="number"
                  placeholder="Width"
                  value={tvLobbySize.width}
                  onChange={(e) => handleTvLobbySizeChange('width', e.target.value)}
                />
                <input
                  type="number"
                  placeholder="Height"
                  value={tvLobbySize.height}
                  onChange={(e) => handleTvLobbySizeChange('height', e.target.value)}
                />
                <select
                  value={unit}
                  onChange={(e) => setUnit(e.target.value)}
                >
                  <option value="feet">feet</option>
                  <option value="inches">inches</option>
                  <option value="cm">cm</option>
                  <option value="meters">meters</option>
                </select>
              </label>
              
            </div>
          )}
          <br/>
          <br/>
          
          <label>
            How many floors do you need?<br />
            <input
              type="number"
              value={floorCount}
              onChange={handleFloorCountChange}
              min="1"
            />
          </label>
          <br/>
          <div className="button-group">
            <button type="button" onClick={calculateResult}>Get the Price For Your Home</button>
            <button type="button" onClick={resetForm}>Reset</button>
          </div>
              {result && <div className='result'>{result}</div>}
              {price && <div className='result'>{price}</div>}
        </div>
      )}

      {formOption === 2 && (
        <div className="glass-form">
          <h2>Commercial Site</h2>
          <label>
            How many rooms do you need for Your Shop?
            <br />
            <input
              type="number"
              value={shopCount}
              onChange={handleShopCountChange}
              min="0"
            />
          </label>

          {shopSizes.map((_, index) => (
            <div key={index} className="size-input">
              <label>
                Shop Romm {index + 1} Size:
                <br />
                <input
                  type="number"
                  placeholder="Width"
                  value={shopSizes[index].width}
                  onChange={(e) => handleSizeShopChange(index, 'width', e.target.value)}
                />
  
                <input
                  type="number"
                  placeholder="Height"
                  value={shopSizes[index].height}
                  onChange={(e) => handleSizeShopChange(index, 'height', e.target.value)}
                />
                <select
                  value={shopSizes[index].unitShop}
                  onChange={(e) => handleSizeShopChange(index, 'unitShop', e.target.value)}
                >
                  <option value="feet">feet</option>
                  <option value="inches">inches</option>
                  <option value="cm">cm</option>
                  <option value="meters">meters</option>
                </select>
              </label>
              </div>
          ))}
          <br/>
          <br/>
         
          <label>
            How many floors do you need?<br />
            <input
              type="number"
              value={shopFloorCount}
              onChange={handleShopFloorCountChange}
              min="1"
            />
          </label>
          <br/>
          <br/>
         
           <div className="button-group">
            <button type="button" onClick={calculateShopResult}>Get the Price For Your Shop</button>
            <button type="button" onClick={resetShopForm}>Reset</button>
          </div>
            {shopResult && <div className='result'>{shopResult}</div>}
            {shopPrice && <div className='result'>{shopPrice}</div>}
        </div>
      )}
    </div>
  );
};

export default Price;
